exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ebx-tuandco-facets-tick__square[data-v-c215c656]{stroke:#000;stroke-opacity:.2}.ebx-tuandco-facets-tick__tick[data-v-c215c656]{stroke:#fff;stroke-width:1.5}", ""]);

// exports
